import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "simple-remove" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Keyboard",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "E_Direct-Message-Copy-19",
				transform: "translate(-908.000000, -148.000000)",
				fill: "currentColor",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-4",
					transform: "translate(498.000000, 130.000000)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group-2",
						children: /* @__PURE__ */ _jsx("g", {
							id: "simple-remove",
							transform: "translate(410.000000, 18.000000)",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M13.7,0.3 C13.3,-0.1 12.7,-0.1 12.3,0.3 L7,5.6 L1.7,0.3 C1.3,-0.1 0.7,-0.1 0.3,0.3 C-0.1,0.7 -0.1,1.3 0.3,1.7 L5.6,7 L0.3,12.3 C-0.1,12.7 -0.1,13.3 0.3,13.7 C0.5,13.9 0.7,14 1,14 C1.3,14 1.5,13.9 1.7,13.7 L7,8.4 L12.3,13.7 C12.5,13.9 12.8,14 13,14 C13.2,14 13.5,13.9 13.7,13.7 C14.1,13.3 14.1,12.7 13.7,12.3 L8.4,7 L13.7,1.7 C14.1,1.3 14.1,0.7 13.7,0.3 Z",
								id: "Shape"
							})
						})
					})
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCross);
export default ForwardRef;
